'use strict';

angular.module('app')
  .controller('ItineraryCtrl', function (item, utils, liveaboard, $rootScope, $routeParams, $location, GTM) {
    var vm = this;

    vm.showSelectedTrip = utils.showSelectedTrip;

    if (item.status === 404) {
      $rootScope.notFound = true;
    } else {
      vm.urlParams = {
        location: $routeParams.location,
        slug: $routeParams.slug,
      };
      vm.itinerary = item.data;
      vm.itinerary.days = utils.bindItinerary(item.data.days);

      utils.bindLogistic(vm.itinerary.descriptions);

      vm.shop = liveaboard;

      GTM.variables({
        country_name: vm.shop.country,
        country_id: vm.shop.countryId,
        area_name: vm.shop.area,
        area_id: vm.shop.areaId,
      });
      GTM.event('page_itinerary_pageview');
    }
  });
